import { casinoService } from '@/services'
import { masterDataService } from '@/services'
import { createMutationMixin } from '@/shared'
import { removeTypename, useQuery } from 'codefabrik-gui-vue/src/apollo'

export const useCreateCasino = (methodName) => createMutationMixin({
  name: methodName,
  service: [casinoService.createCasino, 'casinos.saveSuccess'],
  onSuccess: navigateToManagePage
})

export function useCasinos (name) {
  return {
    mixins: [
      useQuery({
        name: name,
        serviceFn: casinoService.getCasinos,
        variables(){
          return {integrationId: this.$route.params["id"]}
        },
        mappingFunctions: {
          casinos: [(casinoPage) => casinoPage.casino, () => []]
        }
      })
    ]
  }
}

export function useCasinoIntegrationOptionPage ({ limit } = { limit: 0}) {
  return {
    data () {
      return {
        casinoIntegrationOptionPageInput: {
          limit,
          offset: 0,
        }
      }
    },
    methods: {
      handlePageChange (pageNumber) {
        this.casinoIntegrationOptionPageInput = {
          ...this.casinoIntegrationOptionPageInput,
          offset: (pageNumber - 1) * this.casinoIntegrationOptionPageInput.limit
        }
      }
    },
    mixins: [
      useQuery({
        name: 'casinoIntegrationOptionPage',
        serviceFn: casinoService.getCasinoIntegrationOptionPage,
        variables() {
          return {
            input: this.casinoIntegrationOptionPageInput
          }
        }
      })
    ]
  }
}


export function useJurisdictionPage ({ limit } = { limit: 0}) {
  return {
    data () {
      return {
        jurisdictionPageInput: {
          limit,
          offset: 0,
        }
      }
    },
    methods: {
      handlePageChange (pageNumber) {
        this.jurisdictionPageInput = {
          ...this.jurisdictionPageInput,
          offset: (pageNumber - 1) * this.jurisdictionPageInput.limit
        }
      }
    },
    mixins: [
      useQuery({
        name: 'jurisdictionPage',
        serviceFn: masterDataService.getJurisdictionPage,
        variables() {
          return {
            input: this.jurisdictionPageInput
          }
        }
      })
    ]
  }
}

export function useCasino (name, idParam = "id") {
  return {
    mixins: [
      useQuery({
        name: name,
        serviceFn: casinoService.getCasino,
        variables () {
          return { input: { casinoId: this.$route.params[idParam] }}
        },
        mappingFunctions: {
          [name]: [(casino) => removeTypename(casino), () => ({})]
        }
      })
    ]
  }
}


export const useCasinoIntegrationOption = () => ({
  mixins: [
    useQuery({
      name: 'casinoIntegrationOption',
      serviceFn: casinoService.getCasinoIntegrationOption,
      variables() {
        return {
          input: {
            id: this.$route.params.integrationOptionId
          }
        }
      }
    })
  ]
})

export const useJurisdiction = () => ({
  mixins: [
    useQuery({
      name: 'jurisdiction',
      serviceFn: masterDataService.getJurisdiction,
      variables() {
        return {
          input: {
            id: this.$route.params.jurisdictionId
          }
        }
      }
    })
  ]
})

export const useEditCasino = (methodName) => createMutationMixin({
  name: methodName,
  service: [casinoService.editCasino, 'casinos.saveSuccess'],
  mapInput (input) {
    return { id: this.$route.params.id, ...input }
  },
  onSuccess: navigateToManagePage
})

export const useDeleteCasino = (methodName) => createMutationMixin({
  name: methodName,
  service: [casinoService.deleteCasino, 'casinos.deleteSuccess'],
  mapInput () {
    return { id: this.$route.params.id }
  },
  onSuccess: navigateToManagePage
})

export const useCreateCasinoIntegrationOption = () => createMutationMixin({
  name: 'createCasinoIntegrationOption',
  service: [casinoService.createCasinoIntegrationOption, 'casinos.createIntegrationOptionSuccess'],
  onSuccess () {
    this.$router.push({ name: 'casino-integration-option-list' })
  },
})

export const useEditCasinoIntegrationOption = () => createMutationMixin({
  name: 'editCasinoIntegrationOption',
  service: [casinoService.editCasinoIntegrationOption, 'casinos.editIntegrationOptionSuccess'],
  mapInput (input) {
    return {
      ...input,
      id: this.$route.params.integrationOptionId
    }
  },
  onSuccess () {
    this.$router.push({ name: 'casino-integration-option-list' })
  },
})

export const useDeleteCasinoIntegrationOption = () => createMutationMixin({
  name: 'deleteCasinoIntegrationOption',
  service: [casinoService.deleteCasinoIntegrationOption, 'casinos.deleteIntegrationOptionSuccess'],
  mapInput (input) {
    return {
      ...input,
      id: this.$route.params.integrationOptionId
    }
  },
  onSuccess () {
    this.$router.push({ name: 'casino-integration-option-list' })
  },
})

export const useCreateJurisdiction = () => createMutationMixin({
  name: 'createJurisdiction',
  service: [masterDataService.createJurisdiction, 'masterData.createJurisdictionSuccess'],
  onSuccess () {
    this.$router.push({ name: 'casino-jurisdiction-list' })
  },
})

export const useEditJurisdiction = () => createMutationMixin({
  name: 'editJurisdiction',
  service: [masterDataService.editJurisdiction, 'masterData.editJurisdictionSuccess'],
  mapInput (input) {
    return {
      ...input,
      id: this.$route.params.jurisdictionId
    }
  },
  onSuccess () {
    this.$router.push({ name: 'casino-jurisdiction-list' })
  },
})

export const useDeleteJurisdiction = () => createMutationMixin({
  name: 'deleteJurisdiction',
  service: [masterDataService.deleteJurisdiction, 'casinos.deleteJurisdictionSuccess'],
  mapInput (input) {
    return {
      ...input,
      id: this.$route.params.jurisdictionId
    }
  },
  onSuccess () {
    this.$router.push({ name: 'casino-jurisdiction-list' })
  },
})

function navigateToManagePage () {
  this.$router.push({ name: 'manage-casinos' })
}
